import React from 'react'
import { http } from '../../../shared/infrastructure/http'
import { Login } from './Login'
// import { authInMemoryRepository } from '../infrastructure/auth.in.memory.repository'
import { authApiRepository } from '../infrastructure/auth.repository'
import { config } from '../../../config'
const authRepository = authApiRepository(http)
export const LoginFactory = () => <Login repository={authRepository} passwordResetUrl={config.passwordResetUrl}/>
